export default __webpack_public_path__ + "images/Neutrogena_logo.png";